import { Status } from '../../validation';
import isStatusValid from './is_status_valid';

export default (status?: Status): boolean => {
    return !isStatusValid(status);
};
